
import { Injectable } from '@angular/core';
import { BackendService } from '../../backend.service';
import { OtpPurpose, WhatsAppConsent } from './authentication';

@Injectable()
export class AuthenticationService {

    private generateOtpUrl = '/mobile/otp/generate';
    private verifyOtpUrl = '/mobile/otp/verify';
    private setWaConsentUrl = '/growth/whatsapp/consent';
    private partnerUrl = '/preapprove/merchantCustomer/journey/requirement';

    constructor(private backendService: BackendService) { }

    generateOtp(customerId: string, applicationId: string, otpPurpose: OtpPurpose): any {
        const data = {
            CustomerId: customerId,
            ApplicationId: applicationId,
            OtpPurpose: otpPurpose
        };
        return this.backendService.setData(this.generateOtpUrl, data, null, false, false, false, true);
    }
    verifyOtp(otpId: string, otp: string): any {
        const data = {
            OtpId: otpId,
            Otp: otp
        };
        return this.backendService.setData(this.verifyOtpUrl, data, null, false, false, false, true);
    }
    setWhatsAppConsent(waConsent: WhatsAppConsent): any {
        return this.backendService.setData(this.setWaConsentUrl, waConsent);
    }
    getPartnerToken(params: any): any {
        return this.backendService.setData(this.partnerUrl, params);
    }
}
